import { render, staticRenderFns } from "./GitCardSkeleton.vue?vue&type=template&id=303ad36e&scoped=true"
import script from "./GitCardSkeleton.vue?vue&type=script&lang=js"
export * from "./GitCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./GitCardSkeleton.vue?vue&type=style&index=0&id=303ad36e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303ad36e",
  null
  
)

export default component.exports